import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';
import { LoadingState } from './LoadingState';

export const AnonymousEdit = lazyWithSuspense(async () => import('./AnonymousEditScreen'), {
  loadingState: <LoadingState />,
});
